import React from 'react';
import type { LineStyleT } from '../../constants/relationship-renderer';
import { getMidpoint } from '../../utils/relationship-renderer';
import EdgeArrowhead from './edge-arrowhead';
import EdgeLabel from './edge-label';
import EdgeLine from './edge-line';
type PropsT = {
  sourceCenter: [number, number];
  targetCenter: [number, number];
  names: string[];
  color: string;
  textColor?: string;
  directed: boolean;
  lineStyle: LineStyleT;
};
const RelationshipEdge = ({
  sourceCenter,
  targetCenter,
  names,
  color,
  textColor,
  directed,
  lineStyle
}: PropsT) => {
  const [sourceX, sourceY] = sourceCenter;
  const [targetX, targetY] = targetCenter;
  if (sourceX === targetX && sourceY === targetY) return null;
  const midpoint = getMidpoint(sourceCenter, targetCenter);
  const angle = Math.atan2(targetY - sourceY, targetX - sourceX);
  return <g data-testid="relationship-edge">
      <g style={{
      pointerEvents: 'none'
    }}>
        <EdgeLine sourceX={sourceX} sourceY={sourceY} targetX={targetX} targetY={targetY} color={color} lineStyle={lineStyle} />
        {directed && <EdgeArrowhead target={targetCenter} angle={angle} color={color} />}
      </g>
      <EdgeLabel center={midpoint} names={names} backgroundColor={color} textColor={textColor} />
    </g>;
};
export default RelationshipEdge;